import PersonIcon from '@material-ui/icons/Person';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import AddCommentIcon from '@material-ui/icons/AddComment';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseIcon from '@material-ui/icons/Close';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import SharedAdminDrawer, { DRAWER_WIDTH_XL, DRAWER_WIDTH_LG, DRAWER_WIDTH_MD, DRAWER_WIDTH_SM } from './SharedAdminDrawer';
import { useSelector } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import SharedAppBar from './SharedAppBar';
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import useClinicianAuthGuard from './useClinicianAuthGuard';
import VideoCallLauncherDialog from './VideoCallLauncherDialog';
import Yourdiagnosis from '../user_dashboard/data/Yourdiagnosis';
import Prognosis from "../user_dashboard/data/Prognosis";
import Treatmentadvices from "../user_dashboard/data/treatmentadvice/Treatmentadvice";
import { withStyles } from "@material-ui/core/styles";
import PatientListContainer from './patientOverviewFolder/PatientListContainer';
import ExerciseLibrary from './exerciseLibraryFolder/exerciseLibrary';
import Exercise_Searchbar from './exerciseLibraryFolder/searchExercise';
import SelectedPatientExercises from './singlePatientOverviewFolder/selectedPatientProgramBuilder';
import { ChatSystemContainer } from '../../components/ChatSystem';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    paddingBottom: 7,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 57,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.down('xs')]: {
      height: 50,
    },
    [theme.breakpoints.up('sm')]: {
      height: 57,
    },
    [theme.breakpoints.up('md')]: {
      height: 57,
    },
  },
  responsiveLogo: {
    marginTop: 8,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 180,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 190,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 190,
      minWidth: 165,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: {
    minHeight: 57,
    [theme.breakpoints.down('xs')]: {
      minHeight: 50,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 57,
    },
    [theme.breakpoints.up('xl')]: {
      minHeight: 57,
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflowY: 'auto',
    marginTop: 0,
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));



export default function AdminDashboard() {
  const { isAuthorizedClinician } = useClinicianAuthGuard();
  const token = useSelector((state) => state.auth.token);
  const [isLoading, setIsLoading] = useState(false)

  const [isFetching, setIsFetching] = useState(false)
  const [diagnosis, setDiagnosis] = useState({
    title: "",
    identifier: "",
    explainer: ""
  })

  const [prognosis, setPrognosis] = useState({
    Expected_outcome: "",
    Typical_character_Symptoms: "",
    Expected_average_duration: "",
    Expected_development: "",
    If_your_symptoms_worsens: ""
  })

  const [exercises, setExercises] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)
  const [webcamDialogOpen, setWebcamDialogOpen] = useState(false);
  const handleOpenWebcamDialog = () => setWebcamDialogOpen(true);
  const handleCloseWebcamDialog = () => setWebcamDialogOpen(false);
  const [appBarVisible, setAppBarVisible] = useState(true);
  

  const classes = useStyles();
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const activeDrawerWidth = isSm ? DRAWER_WIDTH_SM : isMd ? DRAWER_WIDTH_MD : isXl ? DRAWER_WIDTH_XL : DRAWER_WIDTH_LG;
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  if (!isAuthorizedClinician) {
    return <div>Redirecting...</div>;
  }

  return (
    <div className={`${classes.root} admin-dash`}>
      <CssBaseline />
      {/* <SharedAppBar 
        open={open} 
        drawerWidth={activeDrawerWidth}
        showMessages={true} 
        showVideocall={true}
        onVideocallClick={handleOpenWebcamDialog}
        onVisibilityChange={setAppBarVisible}
      /> */}
      <VideoCallLauncherDialog open={webcamDialogOpen} onClose={handleCloseWebcamDialog} authToken={token} />
      <SharedAdminDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} appBarVisible={appBarVisible} onVideocallClick={handleOpenWebcamDialog} />
      <main className={classes.content} style={{ background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)' }}>
        {/*<div className={classes.appBarSpacer} />*/}
        <Grid Container maxWidth="100%" className={classes.container}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              <PatientListContainer/>
                {/*title={diagnosis.title}
                explainer={diagnosis.explainer}*/}
            </Grid>
          </Grid>
        </Grid>
        {/* Chat System */}
        <ChatSystemContainer />
      </main>
    </div>
  );
}
